/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import { BugReport } from "@material-ui/icons";

export type Props = {
  errorMsg: string;
  reportBug: () => void;
};

const BugReportToast: FC<Props> = ({ errorMsg, reportBug }) => (
  <div>
    <BugReport onClick={reportBug} />
    &nbsp;
    {errorMsg}
  </div>
);

export default BugReportToast;
export type BugReportToastProps = Props;
